<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<vipList v-if="activeTab === '1'" ref="vipList"></vipList>
			<cardChangeHistory v-if="activeTab === '2'" ref="cardChangeHistory"></cardChangeHistory>
			<customerCardChangeList v-if="activeTab === '3'" ref="customerCardChangeList"></customerCardChangeList>
		</topTab>
	</div>
</template>

<script>
import vipList from "./vipList.vue";
import cardChangeHistory from "./cardChangeHistory.vue";
import customerCardChangeList from "./customerCardChangeList.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "会员信息"
				},
				{
					key: "2",
					value: "卡号修改记录"
				},
				{
					key: "3",
					value: "顾客换卡记录"
				}
			]
		};
	},
	// 注册组件
	components: {
		vipList,
		cardChangeHistory,
		customerCardChangeList
	},
	created() {},
	computed: {},
	methods: {
		changePages(tab) {
			this.activeTab = tab;
		}
	}
};
</script>

<style scoped></style>